<template>
    <div id="ii-labels">
<!--        <div class="title-h1 p-2" v-if="interactiveImage.chapterHas()">-->
<!--            {{$t('Chapter')}} {{interactiveImage.chapterGetCurrent().order + 1}}: {{interactiveImage.chapterGetCurrent().title}}-->
<!--        </div>-->
<!--        <div class="hr"></div>-->
        <div class="row align-center" v-if="interactiveImage.isValideBaseImage() && interactiveImage.chapterHas()">
<!--            <div class="col-5">-->
<!--                <input-text v-model="search" :placeholder="$t('Search')"></input-text>-->
<!--            </div>-->
            <div class="col-6">
                <input-select :label="$t('Filters:')" :items="filters" :value="interactiveImage.typeGet()" @change="(type) => interactiveImage.typeSet(type)" form-horizontal ></input-select>
            </div>
            <div class="col-3 relative ml-a mr-1">
                <btn-dropdown :items="$store.getters.labels('interactive_image')" @change="(item) => interactiveImage.labelAdd(item.type)"/>
            </div>
        </div>
        <div class="hr mt-1" v-if="interactiveImage.isValideBaseImage() && interactiveImage.chapterHas()"></div>
        <div class="row wrap" v-if="interactiveImage.isValideBaseImage() && interactiveImage.chapterHas()">
            <draggable
                class="label-items"
                handle=".grip"
                @change="changeLabelOrder"
                v-model="interactiveImage.labelsGet()"
                ghost-class="ghost"
                @start="startDraggable"
                @end="stopDraggable"
                :class="{isDraggable, 'editing':interactiveImage.labelHasEdit()}"
            >
                <Label_Small
                    v-for="(label,k) in interactiveImage.labelsGet()"
                    :label="label"
                    :type="interactiveImage.typeGet()"
                    :key="label.getId()+'_'+label.getObjectType()"
                    @enter="label.enter()"
                    @leave="label.leave()"
                    @select="select(label)"
                    @edit="interactiveImage.labelEdit(label)"
                    @remove="label.remove()"
                    @transfer="labelTransfer = label"
                    @link="labelLink = label"
                />
            </draggable>
        </div>
        <div class="pt-1" v-else>
            <p class="help" v-if="!interactiveImage.isValideBaseImage() && !interactiveImage.chapterHas()">
                {{$t('You need to add a valid Base Image and add 1 chapter to manage labels')}}
            </p>
            <p class="help" v-if="!interactiveImage.isValideBaseImage()">
                {{$t('You need to add a valid Base Image to manage labels')}}
            </p>
            <p class="help" v-if="!interactiveImage.chapterHas()">
                {{$t('You need to add 1 chapter to manage labels')}}
            </p>
        </div>
        <InteractiveImage_Label_Transfer
            :label="labelTransfer"
            :interactiveImage="interactiveImage"
            @close="labelTransfer = false"
            v-if="labelTransfer !== false"
        />
        <LinkContent
            v-if="labelLink"
            :storyId="labelLink.getStoryId()"
            :baseObject="labelLink"
            @close="labelLink = false"
        />
    </div>
</template>

<script>
    import Search from "../../modules/search/Search";
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import Label_Small from "../../modules/labels/Label_Small";
    import InputSelect from "@/modules/input/input-select";
    import events from "@/events/events";
    import InputText from "@/modules/input/input-text";
    import Btn from "@/modules/buttons/btn";
    import BtnDropdown from "@/modules/buttons/btn-dropdown";
    import {interactiveImage} from "@/class/interactive-image/interactiveImage";
    import draggable     from 'vuedraggable'
    import tools from '@/class/tools'
    import InteractiveImage_Label_Transfer from "@/views/interactives-images/InteractiveImage_Label_Transfer";
    import LinkContent from "@/modules/links/LinkContent";
    
    export default {
        name: "InteractiveImage_Labels",
        components: {
            LinkContent,
            InteractiveImage_Label_Transfer,
            BtnDropdown, Btn, InputText, InputSelect, Label_Small, Search,VuePerfectScrollbar,draggable},
        props: {
            interactiveImage:{type:Object,default:() => new interactiveImage()},
            labels: {type: Array, default: () => []},
            loading : {type:Boolean,default:false},
        },
        data() {
            return {
                search:"",
                labelTransfer:false,
                labelLink:false,
                isDraggable:false,
            }
        },
        methods: {
            order(order){
                // console.log(order)
            },
            changeLabelOrder(val){
                let labels = this.interactiveImage.labelsGet();
    
                labels.splice(val.moved.oldIndex,1)
                labels.splice(val.moved.newIndex,0,val.moved.element)
    
                labels.map((label,key) => {
                    label.order =  labels.length - (key + 1);
                })
                
                labels.sort((l1,l2) => {
                    if( l1.order > l2.order) return 1;
                    if( l1.order < l2.order) return -1;
                    if( l1.order === l2.order) return 0;
                })
                
                events.$emit("interactive_image:history:save")
                
                labels.forEach((label) => {
                    label.save(false);
                })
                
                labels[val.moved.newIndex].select()
            },
            startDraggable(){
                this.isDraggable = true;
                this.interactiveImage.labelUnselect()
                this.interactiveImage.labelLeave()
            },
            stopDraggable(){
                this.isDraggable = false;
                this.interactiveImage.labelLeave()
                console.log("stop")
            },
            select(label){
                this.interactiveImage.labelSelect(label);
            }
        },
        watch: {
            loading(){
                if(this.loading) {
                    this.$vs.loading({
                        container: this.$refs.listLabels,
                        scale: 0.5
                    })
                }else{
                    this.$vs.loading.close(this.$refs.listLabels)
                }
            },
            search(){
    
                /* Custom event
                 * Afin de remonter l'information le plus facilement possible, j'utilise un events qui déclanche un trigger au niveau de InteractiveImage.vue
                 * C'est InteractiveImage qui s'occupe de gérer la recherche dans les labes.
                 */
    
                // this.events.$emit("interactive-image:label:search",this.search)
            },
        },
        computed: {
            filters(){
                return [{type:"all",label:"All"},...this.$store.getters.labels('interactive_image')].map(f => {f.text = this.$t(f.label); f.value = f.type; return f;});
            }
        },
    }
</script>